import { render } from "./App.vue?vue&type=template&id=2322be20"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2322be20&lang=scss"

import exportComponent from "../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.2.2_@vue+compiler-sfc@3.0.0-alpha.11_vue@3.2.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__